import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';
import { ActualitesComponent } from "./actualites.component";
import { ActualiteComponent } from './actualite/actualite.component';

const secondaryRoutes: Routes = [
  {
    path: '',
    component: ActualitesComponent
  },
  {
    path: ':type/:id',
    component: ActualiteComponent
  }
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ActualitesComponent,
    ActualiteComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(secondaryRoutes),
    NgbModule,
    ComponentsModule,
  ]
})
export class ActualitesModule {
}
